import { Component, OnInit } from '@angular/core';
import { specialties } from '../users/specialties.component'
import { DoctorService } from '../services/doctors/doctor.service';
import { SpecialtiesService } from '../services/specialties/specialties.service';

import { Doctor } from '../classes/doctor'
import { ProviderService } from '../services/providers/provider.service';
import { PriorityService } from '../services/priorities/priority.service';
import { Auth } from '../services/auth.service';


@Component({
  selector: 'priorities',
  templateUrl: './priorities.component.html',
  styleUrls: ['./priorities.component.css']
})
export class PrioritiesComponent implements OnInit {

  constructor(protected doctorService: DoctorService,
    protected specialtiesService: SpecialtiesService,
    protected providerService: ProviderService,
    protected priorityService: PriorityService,
    protected auth: Auth) { }

  protected deleteCalled: boolean = false;

  realSpecialties: any[]
  specialtiesArray = specialties
  doctors: Doctor[]
  doctorsList: Doctor[] = []
  usersPerGet: Number = 10000
  specialtiesPerGet: Number = 5
  haveUsers: boolean = true
  spec: any //id spec selected
  selectedSpecialtyIndex:string

  providers:any[]
  provider: any //id spec selected
  selectedProviderIndex:string

  priorityItems:any[]
  doctorsWithoutPriority:Doctor[]

  hasPermissionsToEditPriorities:boolean = false;

  ngOnInit() {
    this.hasPermissionsToEditPriorities = this.auth.hasWriteDoctorPermission() || this.auth.hasWriteProviderPermission();
    this.specialtiesService.get({limit:1000}).then((array) => {
      this.realSpecialties = array
    })
    this.providerService.get().then((providers)=>{
      this.providers=providers
    })
  }

  specialtyChanged(event){
    this.search(this.realSpecialties[this.selectedSpecialtyIndex].id)
  }

  search(term: any): void {

   /* if (term == undefined || term == '') return
    this.spec = term

    let params;
    params = { specialty: term }
    params.limit = this.usersPerGet;
    this.doctorService.get(params).then((users: Doctor[]) => {
      this.doctorsList = []
      this.doctors = users
      this.haveUsers = this.doctors.length === this.usersPerGet
      this.sort()
      })*/

  }

  getDoctors(){
    this.spec = this.realSpecialties[this.selectedSpecialtyIndex].realId
    this.provider = this.providers[this.selectedProviderIndex].id
    console.log(this.spec,this.provider)
    var p1 = this.priorityService.getItems(this.spec,this.provider)
    var p2 = this.priorityService.getDoctorsWithoutPriority(this.spec,this.provider)
    return Promise.all([p1,p2]).then((response)=>{
      this.priorityItems = response[0]
      this.doctorsWithoutPriority = response[1]
    })
  }

  sort() {
    let list, lenIds, doc
    let flag:boolean=false
    for (let i = 0; i < this.realSpecialties.length; i++) {
      if (this.realSpecialties[i].id != this.spec) continue
      list = this.realSpecialties[i].prioritizedDoctors
      lenIds = list.length
      for (let j = 0; j < lenIds; j++) {
        doc = this.getById(list[j])
        if (!doc){
          //flag=true
          console.log('uno se fue')
          list.splice(j,1)
          lenIds=list.length
          j--
        }
        else this.doctorsList.push(doc)
      }
      //if (flag) this.specialtiesService.update(this.spec, { prioritizedDoctors: list })
    }


  }

  getById(id) {
    let lenDoc = this.doctors.length
    for (let i = 0; i < lenDoc; i++) {
      if (this.doctors[i].id == id) {
        let doc = this.doctors[i]
        this.doctors.splice(i, 1);
        return doc
      }
    }
    return undefined
  }

  move(doctor: Doctor) {
    this.priorityService.add(this.spec,this.provider,doctor.id).then((item)=>{
      let n = this.doctorsWithoutPriority.indexOf(doctor)
      this.priorityItems.push(item)
      this.doctorsWithoutPriority.splice(n, 1);
    })
  }

  save() {
    let idList = this.doctorsList.map(this.getid)
    this.specialtiesService.update(this.spec, { prioritizedDoctors: idList })
  }

  getid(doc) {
    return doc.id
  }

  moveAll() {
    this.doctorsWithoutPriority.forEach(doc => {
      this.move(doc)
    });
  }

  removePriority(item, index) {
    let providerName = this.providers[this.selectedProviderIndex].name;

    if (!confirm(`Are you sure you want to remove the doctor "${item.doctor.name}" from the priority list of the provider "${providerName}"?`)) return;

    if (this.deleteCalled) {
      return;
    }

    this.deleteCalled = true;

    this.priorityService
      .delete(item.id)
      .then(() => {
        this.priorityItems = this.priorityItems.filter(u => u !== item);
        this.doctorsWithoutPriority.push(item.doctor);
        this.deleteCalled = false;
      })
      .catch(error => {

          this.deleteCalled = false;
          return Promise.reject(error.message || error);
      });
  }

  removeAll() {
    let providerName = this.providers[this.selectedProviderIndex].name;
    let deletedPromise = [];
    if (!confirm(`Are you sure you want to remove all the doctors from the priority list of the provider "${providerName}"?`)) return;

    this.priorityItems.forEach(item => {
      deletedPromise.push(this.priorityService.delete(item.id))
    });

    return Promise.all(deletedPromise)
    .then(() => {
      this.getDoctors()
    })
  }


  movePriority(to,item,index){
    console.log("Move priority:",to);

    var functions = {
      '1':'moveOneUp',
      '-1':'moveOneDown',
      '10':'moveTenUp',
      '-10':'moveTenDown',
      'first':'putFirst',
      'last':'putLast',
    }
    return this.priorityService[functions[to]](item.id).then((response)=>{
      if (to=='first') to="100000"
      else if (to=='last') to="-100000"
      let newPos = index - to
      this.priorityItems.splice(index, 1)
      if (newPos < 0) {
        newPos = 0
      }
      else if (newPos >= this.priorityItems.length) {
        newPos = this.priorityItems.length
      }
      this.priorityItems.splice(newPos, 0, item)
    })

  }

}



// WEBPACK FOOTER //
// ./src/app/priorities/priorities.component.ts